class SendPurchaseToken {
    expiresAt;
    constructor(data) {
        this.expiresAt = new Date(data.expiresAt);
    }
    isExpired() {
        return new Date() >= this.expiresAt;
    }
}
export default SendPurchaseToken;
